<template>
<div class="center-middle">
  <h1 style="font-size:128px;">403</h1>
  <h4>ACCESS DENIED</h4>
</div>
</template>

<script>
export default {

}
</script>

<style>

.center-middle{
  text-align: center;
  position:absolute;
  top:50%;
  left:50%;
  -ms-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}

</style>
